<template>
  <MainContent class="mt-[1.8rem] sm:mt-0" :fullHeight="true">
    <h3 class="text-black text-[24px] capitalize pb-[1.6rem]">{{ title }}</h3>
    <SubContent
      v-for="(appointment, index) in appointments"
      :key="index"
      class="md:mt-[3.2rem] sm:mb-[3.5rem]"
    >
      <slot
        :doctor="appointment.doctor"
        :appointment="appointment"
        name="doctorSlot"
      >
      </slot>
    </SubContent>

    <slot></slot>
  </MainContent>
</template>

<script>
import { defineComponent } from "vue";
import MainContent from "@/components/design/mainContent.vue";
import SubContent from "@/components/design/subContent.vue";

export default defineComponent({
  name: "BaseAccount",
  props: {
    title: {
      type: String,
      required: true,
    },
    appointments: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  components: {
    MainContent,
    SubContent,
  },
});
</script>

<style scoped></style>
